import { Injectable } from '@angular/core';
import { UrlConstants } from 'src/app/_helpers/url-constants';
import { HttpService } from './http.service';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LedgerServiceService {

  // public sharedArray: any[] = [];
  private ledgerDataSubject =  new Subject<void>();
  MasterLedgerData$ = this.ledgerDataSubject.asObservable();

  // allLedgerData$ = this.ledgerDataSubject.asObservable();

  constructor(public httpClient:HttpService) { }
  notifyledgerAdded() {
    this.ledgerDataSubject.next();
  }

  setLedgerData(data: any[]): void {
    console.log("setLedger in service", data);
    // this.ledgerDataSubject.next(data);
  }

  addLedger(data, userId): any {
    return new Promise((resolve, reject) => {
      this.httpClient.inventory(data, UrlConstants.addLedger + userId, 'POST').subscribe(
        (res) => resolve(res),
        (err) => reject(err)
      );
    });
  }

  getUserLedger2(data, userId): any {
    return new Promise((resolve, reject) => {
      this.httpClient.inventory(data, UrlConstants.getUserLedger2 + userId, 'GET').subscribe(
        (res) => resolve(res),
        (err) => reject(err)
      );
    });
  }

  getAllGlnames(data: {}, userId): any {
    return new Promise((resolve, reject) => {
      this.httpClient.inventory(data, UrlConstants.getAllGlnames + userId, 'GET').subscribe(
        (res) => resolve(res),
        (err) => reject(err)
      );
    });
  }
  
  getUserUsecaseData(data: {}, userId): any {
    return new Promise((resolve, reject) => {
      this.httpClient.inventory(data, UrlConstants.getUserUsecaseData + userId, 'GET').subscribe(
        (res) => resolve(res),
        (err) => reject(err)
      );
    });
  }

  addCustomLedger(data: {}, userId): any {
    return new Promise((resolve, reject) => {
      this.httpClient.inventory(data, UrlConstants.addCustomLedger + userId, 'POST').subscribe(
        (res) => resolve(res),
        (err) => reject(err)
      );
    });
  }

  assignLedgersv2(data: {}, userId): any {
    return new Promise((resolve, reject) => {
      this.httpClient.inventory(data, UrlConstants.assignLedgersv2 + userId, 'POST').subscribe(
        (res) => resolve(res),
        (err) => reject(err)
      );
    });
  }

  getUserChildLedger(data: {}, userId): any {
    return new Promise((resolve, reject) => {
      this.httpClient.inventory(data, UrlConstants.getUserChildLedger + userId, 'GET').subscribe(
        (res) => resolve(res),
        (err) => reject(err)
      );
    });
  }

  masterLedgerTrueFalse(data: {}, userId): any {
    return new Promise((resolve, reject) => {
      this.httpClient.inventory(data, UrlConstants.masterLedgerTrueFalse + userId, 'GET').subscribe(
        (res) => resolve(res),
        (err) => reject(err)
      );
    });
  }

  getAllGlcategory(): any {
    return new Promise((resolve, reject) => {
      this.httpClient.inventory({}, UrlConstants.getAllGlcategory, 'GET').subscribe(
        (res) => resolve(res),
        (err) => reject(err)
      );
    });
  }

  getAllGlnamesOptimised(userId, key): any {
    return new Promise((resolve, reject) => {
      this.httpClient.inventory({}, UrlConstants.getAllGlnamesOptimised + userId + `?key=${key}`, 'GET').subscribe(
        (res) => resolve(res),
        (err) => reject(err)
      );
    });
  }

//account ledger
// getAllAccLedger(data: {},userId): any {
//   return new Promise((resolve, reject) => {
//     this.httpClient.inventory({}, UrlConstants.getChartOfAccountsTree +userId, 'GET').subscribe(
//       (res) => resolve(res),
//       (err) => reject(err)
//     );
//   });
// }

getAllAccLedger(userId: string, parentId?: string): any {
  let url = UrlConstants.getChartOfAccountsTree + userId;

  // Append parentId if provided
  if (parentId) {
      url += `?parentId=${parentId}`;
  }

  return new Promise((resolve, reject) => {
      this.httpClient.inventory({}, url, 'GET').subscribe(
          (res) => resolve(res),
          (err) => reject(err)
      );
  });
}


startAccLedgerJourni(data: {},userId): any {
  return new Promise((resolve, reject) => {
    this.httpClient.inventory({}, UrlConstants.startAccountingJourney + userId, 'GET').subscribe(
      (res) => resolve(res),
      (err) => reject(err)
    );
  });
}
DefaultOuterTree(data: {},userId): any {
  return new Promise((resolve, reject) => {
    this.httpClient.inventory({}, UrlConstants.defaultOuterTree + userId, 'GET').subscribe(
      (res) => resolve(res),
      (err) => reject(err)
    );
  });
}

craeteLdgerAcc(data: {}, userId): any {
  return new Promise((resolve, reject) => {
    this.httpClient.inventory(data, UrlConstants.createLedgerAcc + userId, 'POST').subscribe(
      (res) => resolve(res),
      (err) => reject(err)
    );
  });
}

GetAllDefaultledgSetting(data: {},userId): any {
  return new Promise((resolve, reject) => {
    this.httpClient.inventory({}, UrlConstants.getDefaultLedgerSettings + userId, 'GET').subscribe(
      (res) => resolve(res),
      (err) => reject(err)
    );
  });
}
getTrialBalance(data: {},userId,startdate,endDate): any {
  return new Promise((resolve, reject) => {
    this.httpClient.inventory({}, UrlConstants.getTrialBalance + userId + "?startDate=" + startdate + "&endDate=" +endDate, 'GET').subscribe(
      (res) => resolve(res),
      (err) => reject(err)
    );
  });
}
getBalanceSheet(data: {},userId){
  return new Promise((resolve, reject) => {
    this.httpClient.inventory({}, UrlConstants.getBalanceSheet + userId, 'GET').subscribe(
      (res) => resolve(res),
      (err) => reject(err)
    );
  });
}
getJournalSheet(data: {},userId,size,page,partyId?){
  return new Promise((resolve, reject) => {
    this.httpClient.inventory({}, UrlConstants.getJournalSheet + userId + "?size=" + size + "&page=" + page +"&partyId=" +partyId, 'GET').subscribe(
      (res) => resolve(res),
      (err) => reject(err)
    );
  });

}
newProfitAndLoss(data: {},userId,startdate,endDate){
  return new Promise((resolve, reject) => {
    this.httpClient.inventory({}, UrlConstants.newProfitAndLoss + userId + "?startDate=" + startdate + "&endDate=" +endDate, 'GET').subscribe(
      (res) => resolve(res),
      (err) => reject(err)
    );
  });
}

updateDefaultSetting(data,userId): any{
  return new Promise((resolve, reject) => {
    this.httpClient.inventory(data, UrlConstants.updateDefaultSetting + userId, 'PUT').subscribe(
      (res) => resolve(res),
      (err) => reject(err)
    );
  });
}



updateChartOfAccount(data: {}, userId): any {
  return new Promise((resolve, reject) => {
    this.httpClient.inventory(data, UrlConstants.updateChartOfAccount + userId, 'PUT').subscribe(
      (res) => resolve(res),
      (err) => reject(err)
    );
  });
}
getAccountWiseEntriesPnL(data: {},userId,aacId,startdate,endDate,type){
  return new Promise((resolve, reject) => {
    this.httpClient.inventory({}, UrlConstants.getAccountWiseEntriesPnL + userId + "?accountId=" +aacId+ "&startDate=" + startdate + "&endDate=" +endDate + "&type=" + type , 'GET').subscribe(
      (res) => resolve(res),
      (err) => reject(err)
    );
  });

}
getAccountWiseEntriesTB(data: {},userId,aacId,startdate,endDate){
  return new Promise((resolve, reject) => {
    this.httpClient.inventory({}, UrlConstants.getAccountWiseEntriesTB + userId + "?accountId=" +aacId+ "&startDate=" + startdate + "&endDate=" +endDate , 'GET').subscribe(
      (res) => resolve(res),
      (err) => reject(err)
    );
  }); 
}

//  public static getAccountWiseEntriesPnL="ledger/getAccountWiseEntriesPnL/"
//   public static getAccountWiseEntriesTB ="ledger/getAccountWiseEntriesTB/"
}
